import { ParticipantModel } from "Models/ParticipantModel";
import { RootStoreProps } from "Stores/RootStore.types";
import { formatNumberWithNationalCode } from "../../../../utils/phoneUtil";
import { FALLBACK_CONTACT } from "../constants";

/**
 * Resolves contact name for phone-based contacts (SMS)
 * @param otherPtc - The other participant in the conversation
 * @param contactStore - The contact store from root store
 * @param personStore - The person store from root store
 * @returns The resolved contact name
 */
export const resolvePhoneContactName = (
  otherPtc: Partial<ParticipantModel>,
  contactStore: RootStoreProps['contact'],
  personStore: RootStoreProps['person']
): string => {
  const phoneNum = formatNumberWithNationalCode(otherPtc.phone);
  const contact = contactStore.getContactByPhoneNumber(otherPtc.phone);
  if (!contact) {
    return phoneNum;
  };
  const extrContact = personStore.getExtrContactByPhoneNumber(contact.phoneNumber);
  return extrContact?.name || contact.DisplayName || phoneNum;
};

/**
 * Resolves contact name for person-based contacts
 * @param otherPtc - The other participant in the conversation
 * @param personStore - The person store from root store
 * @param topic - The conversation topic as fallback
 * @returns The resolved contact name
 */
export const resolvePersonContactName = (
  otherPtc: Partial<ParticipantModel>,
  personStore: RootStoreProps['person'],
  topic: string
): string => {
  const person = personStore.loadPersonByIdGetIfMissingGet(otherPtc.personId.toString());

  // Handle case where person lookup returns undefined/null
  if (!person || typeof person.case !== 'function') {
    return topic || FALLBACK_CONTACT;
  }

  return person.case({
    fulfilled: (res) => res?.name || topic || FALLBACK_CONTACT,
    pending: () => topic || FALLBACK_CONTACT,
    rejected: () => topic || FALLBACK_CONTACT,
  });
};